export const BEDROOMS_CEILING = 7
export const IMAGE_PROVIDER_CDN_URL = 'https://cdn.filestackcontent.com'
